import React, { useEffect, useRef, useState } from 'react'
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Layout from '../common/Layout';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';

const Scores = () => {

    const { quizId } = useParams()

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const navigate = useNavigate()

    const [quizScoreData, setQuizScoreData] = useState([])

    useEffect(() => {
        getQuizScores()
    }, [])

    const getQuizScores = () => {
        ApiHelper.get(`${API_ENDPOINTS.QUIZ_SCORES}/${quizId}`).then((res) => {
            // console.log('res: ', res);
            if (res.status === 200) {
                setQuizScoreData(res?.data?.data)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const nameBodyTemplate = (rowData) => {
        return (
            rowData?.zoneName ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color:'blue', cursor:'pointer' }} onClick={() => navigate(`/quiz/${quizId}/scores/edit/${rowData.scoreMasterId}`)} >
                    {rowData?.zoneName}
                </div>
            ) : null
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.isActive ? 'bg-success' : 'bg-danger'} `}>
                {rowData.isActive ? 'Active' : 'Inactive'}
            </span>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <button onClick={() => navigate(`/quiz/${quizId}/scores/edit/${rowData.scoreMasterId}`)} className="btn btn-primary btn-sm me-2"> <i class="bi bi-pencil-square"></i> </button>
                <button onClick={() => confirmDeleteDailog(rowData.scoreMasterId)} className="btn btn-danger btn-sm"> <i class="bi bi-trash"></i> </button>
            </>
        );
    };

    const confirmDeleteDailog = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteQuizScore(id),
        });
    };

    const deleteQuizScore = (id) => {
        ApiHelper.delete(`${API_ENDPOINTS.QUIZ_SCORES}/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getQuizScores();
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

  return (
    <>
        <Toast ref={toast} />
        <ConfirmDialog/>
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"> <p className="breadcrumb-item active mb-0" aria-current="page">Manage Results</p> </span></h4>
                        <div>
                            <Link to="/quiz" class="btn btn-secondary">⬅ Go Back</Link>
                            <Link class="btn btn-primary mx-2" to={`/quiz/${quizId}/scores/add`} >Add New Scores</Link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={quizScoreData} tableStyle={{ minWidth: '50rem' }} >
                                        <Column body={serialNoTemplate} header='S.NO' />
                                        <Column sortable header='Name' body={nameBodyTemplate} field='zoneName' />
                                        <Column sortable header='Min Score' field='minScore' />
                                        <Column sortable header='Max Score' field='maxScore' />
                                        <Column sortable header='Result Type' field='type' />
                                        <Column sortable header='Status' body={statusBodyTemplate} />
                                        <Column sortable header='Action' body={actionBodyTemplate} />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </>
  )
}

export default Scores
